"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineAlert = exports.AlertBaseStyleName = exports.InlineAlertType = exports.MessageClass = exports.ContentClass = exports.ColorMap = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var TypeStyle = require("typestyle");
var StatusIcons_1 = require("../../icons/StatusIcons");
var Declarative_1 = require("../../utils/Declarative");
exports.ColorMap = {
    success: {
        borderColor: '#008057',
        backgroundColor: '#F2F8F6',
        hoverColor: '#E5F1ED',
    },
    info: {
        borderColor: '#2979B2',
        backgroundColor: '#EEF5FB',
        hoverColor: '#DEEBF3',
    },
    warning: {
        borderColor: '#FECA56',
        backgroundColor: '#FEF9EF',
        hoverColor: '#FDF3E0',
    },
    error: {
        borderColor: '#C93A47',
        backgroundColor: '#F9EBEC',
        hoverColor: '#F3D8DA',
    },
};
var AlertTestId = 'InlineAlert';
var IconClass = 'alertIcon';
exports.ContentClass = 'contentContainer';
exports.MessageClass = 'alertMessage';
var InlineAlertType;
(function (InlineAlertType) {
    InlineAlertType["Success"] = "success";
    InlineAlertType["Info"] = "info";
    InlineAlertType["Warning"] = "warning";
    InlineAlertType["Error"] = "error";
})(InlineAlertType = exports.InlineAlertType || (exports.InlineAlertType = {}));
exports.AlertBaseStyleName = TypeStyle.style({
    borderRadius: 2,
    borderLeft: "4px solid transparent",
    boxSizing: 'border-box',
    display: 'flex',
    fontSize: '12px',
    letterSpacing: '0.2px',
    lineHeight: 1.5,
    $nest: (_a = {},
        _a["& ." + IconClass] = {
            flexShrink: 0,
            marginLeft: 8,
            marginTop: 5,
        },
        _a["& ." + exports.ContentClass] = {
            display: 'flex',
            flexGrow: 1,
        },
        _a['& button'] = {
            margin: 0,
        },
        _a['&.success'] = {
            backgroundColor: exports.ColorMap.success.backgroundColor,
            borderColor: exports.ColorMap.success.borderColor,
        },
        _a['&.info'] = {
            backgroundColor: exports.ColorMap.info.backgroundColor,
            borderColor: exports.ColorMap.info.borderColor,
        },
        _a['&.warning'] = {
            backgroundColor: exports.ColorMap.warning.backgroundColor,
            borderColor: exports.ColorMap.warning.borderColor,
        },
        _a['&.error'] = {
            backgroundColor: exports.ColorMap.error.backgroundColor,
            borderColor: exports.ColorMap.error.borderColor,
        },
        _a),
});
exports.InlineAlert = React.forwardRef(function (props, ref) {
    var children = props.children, className = props.className, interactiveElement = props.interactiveElement, testId = props.testId, type = props.type, htmlProps = tslib_1.__rest(props, ["children", "className", "interactiveElement", "testId", "type"]);
    return (React.createElement("div", tslib_1.__assign({ "aria-atomic": true, "aria-live": 'polite' }, htmlProps, { className: TypeStyle.classes(exports.AlertBaseStyleName, className, type), "data-tb-test-id": Declarative_1.makeTestId(testId, AlertTestId), ref: ref }),
        React.createElement(StatusIcons_1.StatusIcon, { type: type, className: IconClass }),
        React.createElement("div", { key: 'contentContainer', className: exports.ContentClass },
            React.createElement("div", { className: exports.MessageClass }, children),
            interactiveElement)));
});
//# sourceMappingURL=InlineAlertBase.js.map